module.exports = __webpack_public_path__ + "img/bgc2.7839d8f8.png";